<!--examBasic:新高考考试概况 2023/11/17 15:11:44 YuAng-->

<template>
  <div class="gaokao-basic">
    <el-card class="basic-card">
      <p>
        本次考试，统计总人数
        <span class="num">{{ totalNum }}</span>
        人。均分为
        <span class="num">{{ avgScore }}</span>
        分，最高分为
        <span class="num">{{ maxScore }}</span>
        分
      </p>
      <p v-for="item, index in basicTable" :key="'basicTable' + index">
        {{ item.lineName }}模拟上线（
        <span class="num">
          {{ item.totalScore }}
        </span>
        分）人数
        <span class="num">
          {{ item.stuNum }}
        </span>人（
        <span class="num">
          {{ item.stuRate }}
        </span>）
      </p>
    </el-card>
    <el-card class="basic-card">
      <el-table :data="basicTable" border style="width: 100%" size="mini">
        <el-table-column prop="lineName" label="分数线名称" align="center"></el-table-column>
        <el-table-column prop="totalScore" label="总分有效分" align="center" :render-header="renderHeader">
          <template slot-scope="scope">
            ≥{{ scope.row.totalScore }}
          </template>
        </el-table-column>
        <el-table-column prop="stuNum" label="学生人数" align="center"></el-table-column>
        <el-table-column prop="stuRate" label="占比" align="center">
          <template slot-scope="scope">
            {{ scope.row.stuRate }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="basic-card">
      <p>
        单上线：单科分值≥有效分，即为单上线，这里统计的是上线人数。
      </p>
      <p>
        双上线：单科和总分成绩均≥有效分，即为双上线。
      </p>
      <p>
        贡献率：(双上线人数/总分上线人数) * 100%
      </p>
      <p>
        命中率：(双上线人数/单科上线人数) * 100%
      </p>
    </el-card>
    <p style="margin-bottom: 10px;">
      <el-button @click="lineKind = 'First'" size="mini" :type="lineKind === 'First' ? 'primary' : ''">特控线</el-button>
      <el-button @click="lineKind = 'Second'" size="mini" :type="lineKind === 'Second' ? 'primary' : ''">本科线</el-button>
    </p>
    <el-card class="basic-card">
      <ul-basic-school is-first :school="localSchool" :line-kind="lineKind"></ul-basic-school>
      <ul-basic-school v-for="school in totalList" :key="'ul' + school.schoolId" :school="school" :line-kind="lineKind"></ul-basic-school>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { wenliReportApi } from '@/utils/api'
import util from '@/utils/util'
import UlBasicSchool from "./components/UlBasicSchool.vue";
export default {
  name: 'examBasic',
  props: {
    item: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      totalNum: 0,
      maxScore: 0,
      avgScore: 0,
      schoolNum: 0,
      basicTable: [
        {
          lineName: '特控线',
          totalScore: 0,
          stuNum: 0,
          stuRate: 0
        },
        {
          lineName: '本科线',
          totalScore: 0,
          stuNum: 0,
          stuRate: 0
        }
      ],
      lineKind: 'First', // First 特控线，Second一本线
      localSchool: {}, // 用户所属学校
      totalList: [] // 除了用户所属学校外的其他学校
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
    apiKey: function () {
      return this.$route.query.reportType + '' === '2' ? 'science' : 'art'
    }
  },
  mounted () {
    // 更新Dom
    this.loadTotal();
    this.loadMap();
  },
  methods: {
    toPointFixed: util.toPointFixed,
    loadTotal () {
      const params = {
        levelExamId: this.$route.params.id,
        type: this.apiKey,
        schoolId: this.userInfo.schoolId
      };
      wenliReportApi.getTotal(params).then(resp => {
        if (resp.body) {
          this.basicTable[0].totalScore = this.toPointFixed(resp.body.firstScore); //特控线分数
          this.basicTable[0].stuNum = resp.body.overFirstNum; //特控线总分人数
          this.basicTable[0].stuRate = resp.body.firstScoreRate; //特控线占比
          this.basicTable[1].totalScore = this.toPointFixed(resp.body.secondScore); //本科线分数
          this.basicTable[1].stuNum = resp.body.overSecondNum; //本科线总分上线人数
          this.basicTable[1].stuRate = resp.body.secondScoreRate; //本科线占比
          this.totalNum = resp.body.studentNum; //学生总数量
          this.maxScore = this.toPointFixed(resp.body.maxScore);
          this.avgScore = this.toPointFixed(resp.body.averageScore);
          this.schoolNum = resp.body.schoolNum || '--';
        }
      });
    },
    loadMap () {
      const params = {
        levelExamId: this.$route.params.id,
        type: this.apiKey,
        schoolId: this.userInfo.schoolId
      };
      wenliReportApi.getTotalDetail(params).then(resp => {
        if (resp.body) {
          const firstList = resp.body[this.userInfo.schoolId];
          if (firstList) {
            this.localSchool = this.getObj(firstList);
          }
          const list = [];
          const keys = Object.keys(resp.body);
          for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            if (key === this.userInfo.schoolId) continue;
            const statistics = resp.body[key]
            const item = this.getObj(statistics)
            item.schoolName = statistics && statistics.length > 0 ? statistics[0].orgName : '';
            list.push(item);
          }
          this.totalList = list;
        }
      });
    },
    getObj (arr) {
      const firstObj = arr.find(item => item.subject === 'summary');
      return {
        ...(firstObj || {}),
        subjects: arr.filter(item => item.subject !== 'summary')
      };
    },
    renderHeader (h, { column, $index }) {
      let html = h("el-tooltip", {
        props: {
          placement: "top",
          content: '最后一名上线学生的总分'
        }
      }, [h("i", { class: "el-icon-question" }, "")]);
      return h("span", {}, [h("span", { style: { 'margin-right': '4px' } }, column.label), html]);
    },
  },
  components: { UlBasicSchool }
}
</script>

<style scoped>
.gaokao-basic {
  flex: 1;
  box-sizing: border-box;
  margin-top: 14px;
  width: 0;
}

.basic-card {
  line-height: 1.5;
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
  overflow: auto;
}

.num {
  color: #f56c6c;
  font-weight: bold;
}

.basic-card ::v-deep .el-icon-question {
  font-size: 14px;
  color: #666;
}
</style>